<!--
 * @Author: 'llhj' llhj0326@163.com
 * @Date: 2023-11-06 16:38:12
 * @LastEditors: 'llhj' llhj0326@163.com
 * @LastEditTime: 2025-02-21 15:30:55
 * @FilePath: \front\src\views\System\dataManage\dataBatchModify.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div  class="about">
        <div class="pg-header">
			<div><label class="title">批量修改</label></div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<span>系统管理</span>|
					<span>数据管理</span>|
					<span>批量修改</span>
				</div>
			</div>
		</div>
        <el-tabs class="customize tab-divide" @tab-click="handleTab" v-model="currentTab">
            <el-tab-pane label="院中管理" name="t1" class="bg-w" :key="1" :lazy="true">
                <DataManageForm :form="form" :options="inHospitalOption" @openTipsEvent="openTips" :loading="isLoading" :currentTab="currentTab"/>
            </el-tab-pane>
            <el-tab-pane label="出院(排期)管理" name="t2" :key="2" :lazy="true">
                <DataManageForm :form="form" :options="scheduleOption" @openTipsEvent="openTips" :loading="isLoading" :currentTab="currentTab"/>
            </el-tab-pane>
            <el-tab-pane label="门诊(排期)管理" name="t3" class="bg-w" :key="3" :lazy="true">
                <DataManageForm :form="form" :options="scheduleOption" @openTipsEvent="openTips" :loading="isLoading" :currentTab="currentTab"/>
            </el-tab-pane>

            <el-tab-pane label="随访管理" name="t4" :key="4" :lazy="true">
                <span slot="label">
                    <el-dropdown  @command="selectEvt">
                        <span class="el-dropdown-link">
                            随访管理<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="t4">随访状态修改</el-dropdown-item>
                            <el-dropdown-item command="t5">随访状态删除</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </span>
                <DataManageForm :form="form" :options="followOption" @openTipsEvent="openTips" :loading="isLoading" :currentTab="currentTab" :childTab="childTab"/>
            </el-tab-pane>
            <el-tab-pane label="复诊管理" name="t6" :key="6" :lazy="true">
                <span slot="label">
                    <el-dropdown  @command="selectEvt">
                        <span class="el-dropdown-link">
                            复诊管理<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="t6">出院时间删除</el-dropdown-item>
                            <el-dropdown-item command="t7">预约时间删除</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </span>
                <DataManageForm :form="form" :options="followOption" @openTipsEvent="openTips" :loading="isLoading" :currentTab="currentTab" :childTab="childTab"/>
            </el-tab-pane>
        </el-tabs>
        <el-dialog title="" width="750px" center :visible.sync="dialogVisible">
            <template v-if="dialogState=='tips'">
                <el-row  class="tipsRow">
                    <el-col :span="24"><img src="../../../assets/images/tips.png" alt="" srcset=""></el-col>
                    <el-col :span="24"><h2>本次操作将修改数据，请谨慎操作！</h2></el-col>
                    <el-form class="tipsForm">
                        <el-col :span="24"><el-form-item label="科室名称未填写情况下，默认为全院科室数据" required></el-form-item></el-col>
                        <el-col :span="24"><el-form-item :label="tipsText+'时间(起)、结束时间(止)均未填写情况下，默认范围为自系统上线之日到当前时间'" required></el-form-item></el-col>
                        <el-col :span="24"><el-form-item :label="tipsText+'时间(起)未填写情况下，默认范围为自系统上线之日到结束(止)时间'" required></el-form-item></el-col>
                        <el-col :span="24"><el-form-item label="结束时间(止)未填写情况下，默认范围为自系统上线之日到当前时间" required></el-form-item></el-col>
                        <el-form-item class="formBot">
                            <el-button @click="closeDlg">取 消</el-button>
                            <el-button type="primary" @click="saveForm">确 定</el-button>
                        </el-form-item>
                    </el-form>
                </el-row>
                
            </template>
            <template v-if="dialogState=='success'">
                <el-row class="tipsRow">
                    <el-col :span="24"><img src="../../../assets/images/editSuccess.png" alt="" srcset=""></el-col>
                    <el-col :span="24"><h2>批量修改成功！</h2></el-col>
                </el-row>
                <div class="formBot">
                    <el-button type="primary" @click="closeDlg">完成</el-button>
                </div>
            </template>
		</el-dialog>
    </div>
</template>

<script>
import api from '@/service/api.js';
import dayjs from 'dayjs';
import DataManageForm from '../components/dataManageForm.vue'

export default {
    components:{DataManageForm},
    data(){
        return{
			currentTab: 't1',
            form:{
                form:{
                    startDate:'',
                    endDate:'',
                    newState:'',
                    oldState:'',
                    departments:'',
                },
                deptList:[]
            },
            isLoading:false,
            inHospitalOption:[
                {
                    value:0,
                    label:'待管理'
                },
                {
                    value:1,
                    label:'管理中'
                },
                {
                    value:2,
                    label:'已完成'
                },
                {
                    value:3,
                    label:'已过期'
                },
                {
                    value:4,
                    label:'勿访'
                }
            ],
            scheduleOption:[
                {
                    value:1,
                    label:'待排期'
                },
                {
                    value:2,
                    label:'已排期'
                },
                {
                    value:3,
                    label:'勿访'
                },
                {
                    value:5,
                    label:'排期过期-待排期'
                },
                {
                    value:6,
                    label:'排期过期-已排期'
                },
                {
                    value:7,
                    label:'排期过期-勿访'
                },
                
            ],
            followOption:[
                {
                    value:1,
                    label:'待随访'
                },
                {
                    value:3,
                    label:'暂存'
                },
                {
                    value:2,
                    label:'已随访'
                },
                {
                    value:4,
                    label:'终止随访'
                },
            ],
            dialogVisible:false,
            dialogState:'',
            departmentType:1,
            tipsText:'入院',
            childTab:''
        }
    },
    created(){
        this.departmentType=0;
        this.getDepList('t1');
    },
    methods:{
        
        handleTab(tab) {
            switch (tab.name){
                case 't1':{
                    this.departmentType=0;
                    this.tipsText='入院';
                    break;
                }
                case 't2':{
                    this.departmentType=0;
                    this.tipsText='出院';
                    break;
                }
                case 't3':{
                    this.departmentType=1;
                    this.tipsText='门诊';
                    break;
                }
                case 't4':{
                    this.departmentType=1;
                    this.tipsText='出院';
                    break;
                }
            }
            this.reset();
            this.getDepList(tab.name);
            console.log(tab.name,'=========',this.departmentType);
		},
        selectEvt(command){
            this.childTab=command;
        },
        getDepList(tab){
            switch(tab){
                case 't1':
                case 't2':
                case 't3':{
                    // 获取 院中 出院科室下拉
                    api.getDeptDropdown({departmentType:this.departmentType}).then((res)=>{
                        if (res.code == 1000 && res.data) {
                            this.form.deptList = res.data;
                            // this.form2.deptList=res.data
                        }
                    })
                    break;
                }
                case 't4':{
                    // 获取随访科室下拉
                    api.getDeptDropdown({}).then((res)=>{
                        if (res.code == 1000 && res.data) {
                            this.form.deptList = res.data;
                        }
                    })
                    break;
                }
            }
        },
        openTips(data){
            console.log(data,'========da22');
            this.dialogState='tips';
            this.dialogVisible=true;
        },
        async saveForm() {
            this.dialogVisible=false;
            this.dialogState='';
            this.form.form.startDate = this.form.form.startDate?dayjs(this.form.form.startDate).format('YYYY-MM-DD 00:00:00'):'';
			this.form.form.endDate = this.form.form.endDate?dayjs(this.form.form.endDate).format('YYYY-MM-DD 23:59:59'):'';
            let res;
            if(this.childTab){
                switch(this.childTab){
                    case 't5':
                        res= await api.delFollowup(this.form.form);
                    break;
                    case 't6':
                        this.form.form.dataState=1;
                        res= await api.delAppointmentReturnByOutDate(this.form.form);
                    break;
                    case 't7':
                        this.form.form.dataState=1;
                        res= await api.delAppointmentReturnByAppDate(this.form.form);
                    break;
                }
            }else {
                switch(this.currentTab){
                    case 't1':
                        res= await api.inhospitalModifyStatusInBatch(this.form.form);
                        break;
                    case 't2':
                        res= await api.outhospitalModifyStatusInBatch(this.form.form);
                        break;
                    case 't3':
                        res= await api.outpatientModifyStatusInBatch(this.form.form);
                        break;
                    case 't4':
                        console.log(this.form.form.stopType,'---------sss');
                        if(this.form.form.stopType==1){
                            res= await api.followupModifyStatusInBatch(this.form.form);
                        } else if(this.form.form.stopType==2){
                            res= await api.followupModifyStatusInBatchAll(this.form.form);
                        }
                        break;
                    
                }
            }
            if(res.code==1000){
                this.dialogState='success';
                this.dialogVisible=true;
                this.reset();
            }
		},
        reset(){
            this.form.form={
                    startDate:'',
                    endDate:'',
                    newState:'',
                    oldState:'',
                    departments:'',
                }
        },
        closeDlg(){
            this.dialogVisible=false;
            this.dialogState='';
            this.reset();
        }
        
    }
}
</script>

<style lang="less" scoped>
@import '@/assets/style/var';

.el-tabs {
    ::v-deep .el-tabs__content{
        background: #fff;
    }
    
	&.customize {
		.el-tabs__nav-wrap {
			padding: 10px 30px 12px;

			&::after {
				display: none!important;
			}
		}
		.el-tab-pane {&.pad { padding: 10px 30px 20px;}}
	}
}
.el-form{
    width: 510px;
    margin:0 auto;
    padding: 80px 0;
}
.tipsForm{
    width: 700px;
    padding-bottom: 20px;
    ::v-deep .el-form-item__label{
        color: #8B8B8B;
        text-align: center;
        width: 100%;
    }
}
.tipsRow{
    .el-col-24{
        text-align: center;
        img{
            width: 51px;
            height: 51px;
        }
    }
}

.formBot{
    text-align: center;
    margin-top: 80px;
    ::v-deep .el-form-item__content{
        margin-left: 0 !important;
    }
    .el-button{
            width: 100px;
            margin: 0 16px;
        }
}
</style>